/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const PaperClip: React.FC<Props> = ({ ...props }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.26936 2.78038C9.74965 0.406565 13.7579 0.406517 16.2381 2.78038L16.4657 3.00889C18.7351 5.41408 18.6589 9.13996 16.2381 11.4571L9.67561 17.7384C7.89929 19.4385 5.03195 19.4387 3.25569 17.7384C1.46138 16.0205 1.46142 13.221 3.25569 11.503L9.72444 5.31163C10.7967 4.28524 12.5223 4.28526 13.5946 5.31163L13.786 5.51475C14.6805 6.56632 14.6168 8.12774 13.5946 9.10655L7.07893 15.3439C6.7798 15.6301 6.30481 15.6193 6.01839 15.3204C5.73197 15.0212 5.7426 14.5463 6.04182 14.2599L12.5575 8.02354C13.0014 7.59856 13.0286 6.93799 12.6405 6.4835L12.5575 6.39561L12.5526 6.38975C12.0599 5.92346 11.2521 5.92523 10.7616 6.39464L4.29378 12.587C3.11618 13.7144 3.11609 15.528 4.29378 16.6554C5.48999 17.8 7.44234 17.8 8.6385 16.6554L15.201 10.3732C17.024 8.62812 17.081 5.84606 15.3719 4.03624L15.201 3.86436C13.3007 2.04539 10.2068 2.04543 8.30647 3.86436L3.01839 8.92589C2.71925 9.21222 2.24429 9.20142 1.95784 8.90245C1.67179 8.60326 1.68233 8.12922 1.98128 7.84288L7.26936 2.78038Z"
      fill={props.color ?? props?.style?.color}
    />
  </svg>
);

export default PaperClip;
